import dayjs from 'dayjs';
import { isNumber } from 'underscore';

export const getDaysUntilNow = (sec: number) => {
  if (isNumber(sec)) {
    return Math.ceil(Math.max(0, dayjs.unix(sec).diff(dayjs(), 'days', true)));
  }
  return sec;
};
